<script>
    import { onMount } from "svelte";

    import { isEqual, cloneDeep } from "lodash";

    export let filter = {};
    export let defaultFilter = {};
    export let specialVariables = {}; 
    export let onResetFilter = () => {};

    $: isResetLinkVisible =
        !isEqual(filter, defaultFilter) ||
        !isEqual(specialVariables, defaultSpecialVariables);

    let isResettingFilter = false;

    let defaultSpecialVariables;

    onMount(() => {
        defaultFilter = { ...filter, ...defaultFilter };
        defaultSpecialVariables = cloneDeep(specialVariables);
    });

    const handleResetFilter = async () => {
        if (isResettingFilter) return;

        isResettingFilter = true;

        filter = { ...defaultFilter };
        onResetFilter();

        isResettingFilter = false;
    };
</script>

{#if isResetLinkVisible}
    <p
        class="underline cursor-pointer hover:font-bold"
        on:click|preventDefault={handleResetFilter}
    >
        Reset filter
    </p>
{/if}
